var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('coin-badge',{attrs:{"amount":_vm.creatorLivestream.totalEarnings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }